export const allTheOtherFields = [
  { label: 'Birth date', value: 'birthDate' },
  { label: 'Birth year', value: 'birthYear' },
  { label: 'Business categories', value: 'businessCategories' },
  { label: 'Business name', value: 'businessName' },
  { label: 'City', value: 'city' },
  { label: 'Country', value: 'country' },
  { label: 'Date added', value: 'dateAdded' },
  { label: 'Date of death', value: 'dateOfDeath' },
  { label: 'Date updated', value: 'dateUpdated' },
  { label: 'Deceased', value: 'deceased' },
  { label: 'Domains', value: 'domains' },
  { label: 'First name', value: 'firstName' },
  { label: 'Gender', value: 'gender' },
  { label: 'Industries', value: 'industries' },
  { label: 'Interests', value: 'interests' },
  { label: 'Job function', value: 'jobFunction' },
  { label: 'Job level', value: 'jobLevel' },
  { label: 'Job skills', value: 'jobSkills' },
  { label: 'Job title', value: 'jobTitle' },
  { label: 'Keys', value: 'keys' },
  { label: 'Last name', value: 'lastName' },
  { label: 'Licenses', value: 'licenses' },
  { label: 'Linkedin URL', value: 'linkedinURL' },
  { label: 'Num employees max', value: 'numEmployeesMax' },
  { label: 'Num employees min', value: 'numEmployeesMin' },
  { label: 'Personal emails', value: 'personalEmails' },
  { label: 'Postal code', value: 'postalCode' },
  { label: 'Primary email', value: 'primaryEmail' },
  { label: 'Professional emails', value: 'professionalEmails' },
  { label: 'Properties Owned History', value: 'propertiesOwnedHistory' },
  { label: 'Properties Represented', value: 'propertiesRepresented' },
  { label: 'Province', value: 'province' },
  { label: 'Source URLs', value: 'sourceURLs' }
];

export const mostCommonFieldsList = [
  { label: 'Address', value: 'address' },
  { label: 'Emails', value: 'emails' },
  { label: 'Phone numbers', value: 'phoneNumbers' }
];